import { render, staticRenderFns } from "./ArchivedGroupHome.vue?vue&type=template&id=eddd0b40"
import script from "./ArchivedGroupHome.vue?vue&type=script&lang=js"
export * from "./ArchivedGroupHome.vue?vue&type=script&lang=js"
import style0 from "./ArchivedGroupHome.vue?vue&type=style&index=0&id=eddd0b40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports